import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../support/with_presenter';
import {TrainingPlanSelectorPresenter} from './TrainingPlanSelectorPresenter';
import {TrainingPlanSearchModal} from './TrainingPlanSearchModal/TrainingPlanSearchModal';
import {If} from '../../../components/if';
import {SelectedList} from './SelectedList/SelectedList';
import {TrainingPlan} from '../models/TrainingPlan';

interface OwnProps {
    trainingPlans?: TrainingPlan[];
}

const TrainingPlanSelectorComponent: FunctionComponent<OwnProps & PresenterProps<TrainingPlanSelectorPresenter>> =
    observer(({presenter}) => {
        return (
            <div>
                <If condition={presenter.isEmpty}>
                    <div className="training-plan-element-selector__empty">
                        <div />
                        <div />
                        <div />
                    </div>
                </If>
                <If condition={!presenter.isEmpty}>
                    <SelectedList
                        trainingPlans={presenter.selection}
                        onOrderChange={(trainingPlans) => presenter.onSelectionOrderChange(trainingPlans)}
                    >
                        {(trainingPlan, index) => (
                            <>
                                <input
                                    type="hidden"
                                    name={'training_plan[' + index + '][id]'}
                                    value={trainingPlan.id}
                                />
                                <span>{trainingPlan.title}</span>
                                {trainingPlan.title !== trainingPlan.title && (
                                    <small className="training-plan-element-selector__selected-list-item-title-hint">
                                        ({trainingPlan.title})
                                    </small>
                                )}
                                <button
                                    className="training-plan-element-selector__selected-list-item-trash ion-md-trash"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        presenter.onTrashClick(trainingPlan);
                                    }}
                                />
                            </>
                        )}
                    </SelectedList>
                </If>
                <div
                    className="btn btn-secondary pull-right icon-left ion-md-add"
                    onClick={() => presenter.onClickSearch()}
                >
                    Add training plan
                </div>
                <TrainingPlanSearchModal
                    visible={presenter.searchVisible}
                    onDismiss={presenter.onSearchHide.bind(presenter)}
                    onSubmit={(trainingPlans) => presenter.onSearchSubmit(trainingPlans)}
                />
            </div>
        );
    });

export const TrainingPlanSelector = withPresenter<TrainingPlanSelectorPresenter, OwnProps>(
    (props, component) => new TrainingPlanSelectorPresenter(props.trainingPlans),
    TrainingPlanSelectorComponent,
);
